"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var core_1 = require("@angular/core");
var toggle_full_screen_service_1 = require("./api/toggle-full-screen.service");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var flex_layout_1 = require("@angular/flex-layout");
var token_expiration_service_1 = require("../login/token-expiration-manager/token-expiration.service");
var navigation_bar_state_1 = require("../header-bar/model/navigation-bar-state");
var session_prolong_service_1 = require("../../services/session-prolong.service");
var routing_audit_service_1 = require("../../services/routing-audit.service");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
/**
 * Created by Hayk.Andriasyan on 10/13/2017.
 */
var ShellContainerComponent = /** @class */ (function () {
    function ShellContainerComponent(route, toggleFullScreenService, currentLanguageProvider, media, tokenExpirationService, sessionProlongService, _eventBase, routingAuditService, applicationPropertiesService, tokenInfoService) {
        this.route = route;
        this.toggleFullScreenService = toggleFullScreenService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.media = media;
        this.tokenExpirationService = tokenExpirationService;
        this.sessionProlongService = sessionProlongService;
        this._eventBase = _eventBase;
        this.routingAuditService = routingAuditService;
        this.applicationPropertiesService = applicationPropertiesService;
        this.tokenInfoService = tokenInfoService;
        this.NavigationBarState = navigation_bar_state_1.NavigationBarState;
        this.isPopupShown = false;
        this.isPopupDisabled = false;
        this.pinState = navigation_bar_state_1.NavigationBarState.PINNED;
        this.isFullScreen = true;
        // holding current language direction.
        // will reload page if direction is changed.
        this._currentLanguageDirection = undefined;
        this._openSubscriptions = [];
    }
    ShellContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._openSubscriptions.push(this.route.queryParams.subscribe(function (params) {
            _this.toggleFullScreenService.setFullScreen(params['fullScreen'] === 'true');
        }));
        this._openSubscriptions.push(this.toggleFullScreenService.isFullScreen().subscribe(function (value) {
            _this.isFullScreen = value;
        }));
        this._openSubscriptions.push(this._eventBase.listen('navigation-bar-pin-state-changed').subscribe(function (event) {
            _this.pinState = event.data.pinState;
        }));
        this._openSubscriptions.push(this.currentLanguageProvider.getCurrentLanguage().subscribe(function (language) {
            _this._currentLanguageDirection = language.getDirection();
        }));
        this._openSubscriptions.push(this.currentLanguageProvider
            .getCurrentLanguage()
            .skip(1)
            .subscribe(function (language) {
            // reload page if direction is changed.
            if (_this._currentLanguageDirection !== undefined &&
                _this._currentLanguageDirection !== language.getDirection()) {
                location.reload();
            }
            _this._currentLanguageDirection = language.getDirection();
        }));
        this._openSubscriptions.push(this.media.subscribe(function (change) {
            // listening to screen changes
            if (change.mqAlias === 'xs' || change.mqAlias === 'sm') {
                _this.pinState = navigation_bar_state_1.NavigationBarState.UNPINNED;
                _this._eventBase.publish('navigation-bar-pin-state-changed', {
                    pinState: _this.pinState
                });
            }
        }));
        this._openSubscriptions.push(this.tokenExpirationService.isTokenValid().subscribe(function (isValid) {
            if (!isValid) {
                _this.isPopupShown = true;
            }
        }, console.error));
        this._openSubscriptions.push(this.tokenInfoService.tokenValidityObservable.distinctUntilChanged().subscribe(function (isValid) {
            if (isValid) {
                _this.sessionProlongService.stop();
                _this.sessionProlongService.start();
            }
            else {
                _this.sessionProlongService.stop();
            }
        }, console.error));
        this.applicationPropertiesService.isOfflineApp()
            .then(function (isOffline) {
            if (!isOffline) {
                _this._openSubscriptions.push(_this.routingAuditService.listen());
            }
        });
    };
    /*@HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (event.altKey && event.keyCode === ENTER) {
            this.toggleFullScreenService.setFullScreen(!this.isFullScreen);
        }
    }*/
    ShellContainerComponent.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (s) { return s.unsubscribe(); });
        this.sessionProlongService.stop();
    };
    ShellContainerComponent.prototype.unPin = function ($event) {
        $event.preventDefault();
        this.pinState = navigation_bar_state_1.NavigationBarState.UNPINNED;
        this._eventBase.publish('navigation-bar-pin-state-changed', {
            pinState: this.pinState
        });
    };
    __decorate([
        core_1.Input('isTokenExpirationPopupDisabled'),
        __metadata("design:type", Object)
    ], ShellContainerComponent.prototype, "isPopupDisabled", void 0);
    ShellContainerComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-shell-container',
            template: require('./shell.container.component.html'),
            styles: [require('./shell.container.component.css')]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            toggle_full_screen_service_1.ToggleFullScreenService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            flex_layout_1.ObservableMedia,
            token_expiration_service_1.TokenExpirationService,
            session_prolong_service_1.SessionProlongService,
            idm_session_data_provider_api_js_1.EventBase,
            routing_audit_service_1.RoutingAuditService,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.TokenInfoService])
    ], ShellContainerComponent);
    return ShellContainerComponent;
}());
exports.ShellContainerComponent = ShellContainerComponent;
//# sourceMappingURL=shell.container.component.js.map